export default "__VITE_PUBLIC_ASSET__aa961d81__"